<template>
    <div class="bg">
        <div class="sharetip" v-if="share" @click="share = false">
            <div class="s"></div>
        </div>
        <div class="bonus-center-box abs-mm">
            <div class="title"></div>
            <div class="wheel">
                <div
                        class="pointer"
                        :style="{ transform: 'rotate(' + bonus.deg + 'deg)' }"
                ></div>
                <div class="item g1"></div>
                <div class="item g1"></div>
                <div class="item g1"></div>
                <div class="item g1"></div>
                <div class="item g1"></div>
                <div class="item g1"></div>
                <div class="item g1"></div>
                <div class="item g1"></div>
            </div>
            <div class="btn b1" @click="rotate" v-if="giftType !== 'finish'"></div>
            <div class="btn b1 b2" @click="goOther" v-if="giftType == 'finish'"></div>
            <div class="btn b3" v-if="giftType == 'finish'"
                 @click="$router.replace('/log?giftRoad=' + $route.query.giftRoad)"></div>
            <a class="btn b4" v-if="giftType == 'finish'" href="http://act.uu.cc/bd/new.php?id=2339"></a>
        </div>
        <div class="logo"></div>
        <div class="virtual-gift-layer" v-if="giftType == 'virtual'">
            <div class="gift-center-box abs-mm">
                <div class="gift-title"></div>
                <div class="gift-name">{{ giftName }}</div>
                <div
                        class="gift-img"
                        :style="{
            'background-image':
              'url(//cdn.original-fun.com/gugong/' + vgiftImgUrl + '.png)',
          }"
                ></div>
                <div class="gift-code">
                    <h6 class="code-title">到《梦幻花园》游戏内领取对应礼包（仅安卓）</h6>
                    <h6 class="code-tips">长按复制</h6>
                    <h6 class="code-txt">{{ giftCode }}</h6>
                </div>
                <div class="gift-btn-box">
                    <div
                            class="gift-btn gift-btn-1"
                            @click="
              $router.replace({ name: 'Home', query: { gameType: 'guide' } })
            "
                    ></div>
                    <div class="gift-btn gift-btn-2" @click="share = true"></div>
                    <a class="gift-btn gift-btn-3" href="http://act.uu.cc/bd/new.php?id=2339"></a>
                    <div
                            class="gift-btn gift-btn-4"
                            @click="$router.replace('/log?giftRoad=' + $route.query.giftRoad)"
                    ></div>
                </div>
            </div>
        </div>
        <div class="real-gift-layer" v-else-if="giftType == 'real'">
            <div class="gift-center-box abs-mm">
                <div class="gift-title"></div>
                <div class="gift-name">{{ giftName }}</div>
                <div class="gift-real-img">
                    <img
                            :src="'//cdn.original-fun.com/gugong/' + giftImgUrl + '.png'"
                            class="pct100"
                    />
                </div>
                <div class="gift-form-box">
                    <div class="gift-form-title">请填写您的收货信息</div>
                    <div class="input-box">
                        <label for="nameInput">收货姓名：</label>
                        <input
                                type="text"
                                id="nameInput"
                                placeholder="请输入您的姓名"
                                v-model="realInputInfo.name"
                        />
                    </div>
                    <div class="input-box">
                        <label for="telInput">电话号码：</label>
                        <input
                                type="number"
                                id="telInput"
                                maxlength="11"
                                placeholder="请输入您的手机"
                                v-model="realInputInfo.tel"
                        />
                    </div>
                    <div class="address-box">
                        <h6 class="address-title">详细地址:</h6>
                        <textarea
                                class="address-area"
                                name
                                id
                                cols="30"
                                rows="4"
                                placeholder="请输入您的详细地址"
                                v-model="realInputInfo.address"
                        ></textarea>
                    </div>
                </div>
                <div class="sm-txt"> 奖励以实物为主，抽中后40日内发货，发货后将以短信形式通知</div>
                <div class="gift-btn-box">
                    <div class="gift-btn gift-btn-5" @click="submitForm"></div>
                </div>
            </div>
        </div>
        <div class="bonused-bg" v-if="giftType == 'finish'">
            <div class="txt">
                您已完成该路线，请继续游览其他路线，获得更多抽奖机会！
            </div>
        </div>
    </div>
</template>

<script>
    //script
    import Tools from '../../scripts/tools';
    import {gsap} from 'gsap';
    //Global
    import Global from '../../scripts/Global';
    import api from '../../scripts/api';

    export default {
        data() {
            return {
                share: false,
                rotated: false,
                bonus: {
                    deg: 0,
                },
                giftRoad: 0,
                giftType: '', //virtual 虚拟奖励  real 实物奖励
                giftName: '',
                giftCode: '',
                giftImgUrl: '',
                vgiftImgUrl: '',
                realInputInfo: {
                    name: '',
                    tel: '',
                    address: '',
                },
            };
        },
        components: {},
        created() {
            _hmt && _hmt.push(['_trackEvent', 'bonus', 'visit', 'finish']);
        },
        mounted() {
            window.bbb = this;
            this.giftRoad = this.$route.query.giftRoad; //从哪条路线进入的抽奖
            if (!this.giftRoad) {
                // alert(1);
                // this.$router.replace({ name: 'Home', query: { gameType: 'guide' } });
            }

            api
                .get('api/query', {params: {user: Global.getUserName()}})
                .then(data => {
                    if (data.data) {
                        let result = data.data.find(d => {
                            return d.bonus_road == this.giftRoad;
                        });
                        //已经中奖
                        if (result) {
                            this.giftType = 'finish';
                            return;
                            if (result.bonus_type === 0) {
                                //已经中了 虚拟
                                this.giftType = 'virtual';
                                this.giftName = result.bonus_name;
                                this.vgiftImgUrl = '游戏礼包'; // '惊喜福袋'; 纪念福袋
                                this.giftCode = result.bonus_code; // 'H232323';
                            } else {
                                //已经中了 实物
                                this.giftType = 'real';
                                this.giftName = result.bonus_name; // '故宫笔记本';
                                this.giftImgUrl = result.bonus_name;
                                this.realInputInfo.name = result.real_name;
                                this.realInputInfo.tel = result.real_tel;
                                this.realInputInfo.address = result.real_address;
                            }
                            return;
                        }
                    }
                });
        },
        computed: {},
        methods: {
            rotate() {
                if (!this.rotated) {
                    let user = Global.getUserName();
                    if (!user) {
                        user = Global.setUserName();
                    }
                    this.rotated = true;

                    let deg = 0;
                    api
                        .get('api/lottery', {
                            params: {
                                road: this.giftRoad,
                                user: Global.getUserName(),
                                channel:window.channel,
                            },
                        })
                        .then(data => {
                            if (!data.err) {
                                const result = data.data;

                                let giftType;
                                let giftName;
                                let giftCode;
                                let giftImgUrl;
                                let vgiftImgUrl;

                                if (result.bonus_type === 0) {
                                    /*   //设置虚拟奖励
                                   this.giftType = 'virtual';
                                   this.giftName = '惊喜福袋'
                                   this.giftCode = 'H232323'*/
                                    giftType = 'virtual';

                                    giftName = result.bonus_name;
                                    vgiftImgUrl = '游戏礼包'; // '惊喜福袋'; 纪念福袋

                                    // giftName = '游戏礼包'; // '惊喜福袋'; 纪念福袋
                                    giftCode = result.bonus_code; // 'H232323';
                                    deg = 360 * 3 + 180;
                                } else {
                                    /*//设置实物奖励
                                    this.giftType = 'real';
                                    this.giftName = '故宫笔记本'
                                    this.giftImgUrl = 'images/gift8-B.png'*/
                                    giftType = 'real';
                                    giftName = result.bonus_name; // '故宫笔记本';
                                    giftImgUrl = result.bonus_name;
                                    deg = 360 * 3 + Global.bonus[result.bonus_name].deg;
                                }
                                this.bonus.deg = deg;
                                setTimeout(() => {
                                    this.giftType = giftType;
                                    this.giftName = giftName;
                                    this.giftCode = giftCode;
                                    this.giftImgUrl = giftImgUrl;
                                    this.vgiftImgUrl = vgiftImgUrl;
                                }, 3300);
                            } else {
                                // alert(data.msg);
                            }
                        });

                    setTimeout(() => {
                        //this.$router.replace('/noBonus');
                    }, 3000);
                }
            },
            submitForm() {
                //  realInputInfo: {
                // name: '',
                // tel: '',
                // address: '',
                if (!this.realInputInfo.name || !this.realInputInfo.tel || !this.realInputInfo.address) {
                    alert("请填写如上信息");
                    return;

                }
                api
                    .get('api/submit', {
                        params: {
                            user: Global.getUserName(),
                            road: this.giftRoad,
                            real_name: this.realInputInfo.name,
                            real_tel: this.realInputInfo.tel,
                            real_address: this.realInputInfo.address,
                        },
                    })
                    .then(data => {
                        // this.$router.replace('/log?giftRoad=' + this.$route.query.giftRoad);
                        this.$router.replace('/done?giftRoad=' + this.$route.query.giftRoad);
                    });
            },
            goOther() {
                this.$router.replace({name: 'Home', query: {gameType: 'guide'}});
            },
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .sm-txt{
        font-size:12px;
        margin:0.3rem;
        background-color:#ffffff45;
        padding:0.1rem;
        word-break:keep-all;
        }
    .bg{
        background-image:url(//cdn.original-fun.com/gugong/BG.jpg);
        background-position:center;
        width:100vw;
        height:100vh;
        max-width:75vh;
        margin:0 auto;
        overflow:hidden;
        background-size:cover;
        background-repeat:no-repeat;
        }
    .bonused-bg{
        background-image:url(//cdn.original-fun.com/gugong/答错提示框.png);
        background-position:center;
        background-repeat:no-repeat;
        background-size:contain;
        height:1.5rem;
        width:100%;
        top:1.4rem;
        line-height:1.5rem;
        color:#fff;
        position:absolute;
        z-index:2;
        .txt{
            margin:0 0.8rem 0 0.8rem;
            line-height:0.4rem;
            position:relative;
            display:flex;
            height:100%;
            flex-direction:column;
            align-items:center;
            justify-content:center;
            // word-break: keep-all;
            }
        }
    .bonus-center-box{margin-top:-0.5rem;height:10rem;z-index:2}
    .title{
        background-image:url(//cdn.original-fun.com/gugong/集齐4枚玉璧.png);
        background-position:center;
        width:6rem;
        height:1.5rem;
        background-size:contain;
        background-repeat:no-repeat;
        position:absolute;
        left:50%;
        margin-left:-3rem;
        z-index:2;
        }
    .btn{
        display:block;
        background-position:center;
        background-size:contain;
        background-repeat:no-repeat;
        width:3.5rem;
        height:1rem;
        margin:0 auto 0 auto;
        z-index:2;
        top:-2rem;
        position:relative;
        &.b1{
            background-image:url(//cdn.original-fun.com/gugong/button试试手气.png);
            }
        &.b2{
            background-image:url(//cdn.original-fun.com/gugong/button游览其他线路.png);
            }
        &.b3{
            background-image:url(./../../assets/gift/gift-btn-4.png);
            }
        &.b4{
            background-image:url(./../../assets/gift/gift-btn-3.png);
            }
        }
    .wheel{
        width:7.5rem;
        height:10.52rem;
        background-image:url(//cdn.original-fun.com/gugong/转盘底.png);
        background-position:center;
        background-size:100% auto;
        background-repeat:no-repeat;
        margin:0 auto 0rem auto;
        pointer-events:none;
        position:relative;
        top:0.5rem;
        .pointer{
            transform-origin:50% 1.5rem;
            transition:all 3s;
            width:1.3rem;
            height:2rem;
            background-image:url(//cdn.original-fun.com/gugong/抽奖转盘指针.png);
            background-position:center;
            background-repeat:no-repeat;
            background-size:contain;
            position:absolute;
            left:50%;
            margin-left:-0.65rem;
            top:3.1rem
            }
        }
    .logo{
        background-image:url(//cdn.original-fun.com/gugong/品牌logo-白.png);
        background-position:center;
        width:3rem;
        height:1rem;
        background-repeat:no-repeat;
        background-size:contain;
        position:absolute;
        bottom:0.4rem;
        left:50%;
        margin-left:-1.5rem;
        z-index:1;
        }
    //中奖弹层
    .virtual-gift-layer, .real-gift-layer{@include fullLayer;position:absolute;left:0;top:0;background::rgba(222, 198, 188, .7);@include maskShow;z-index:5;}
    .gift-title{width:4.51rem;height:0.55rem;background-image:url(./../../assets/gift/gift-title.png);@include singleBg;margin:0 auto;}
    .gift-name{width:2.6rem;height:0.52rem;background-image:url(./../../assets/gift/gift-name-bg.png);@include singleBg;margin:0 auto;margin-top:0.3rem;color:#fff;font-size:0.28rem;line-height:0.52rem;text-align:center;}
    .gift-img{width:3.58rem;height:2.5rem;background-image:url(./../../assets/gift/virtual-img.png);@include singleBg;margin:0 auto;margin-top:0.1rem;}
    .gift-real-img{width:3.58rem;height:2.5rem;margin:0 auto;margin-top:0.1rem;}
    .code-title{width:3.6rem;
        text-align:center; margin:0.2rem auto 0.2rem auto;font-size:0.28rem;}
    .code-tips{font-size:0.24rem;color:#fff;line-height:1;position:relative;width:3rem;text-align:center;margin:0 auto;
        &:before{content:"";position:absolute;width:0.8rem;height:0.02rem;background:#fff;left:0;top:50%;margin-top:-0.01rem;}
        &:after{content:"";position:absolute;width:0.8rem;height:0.02rem;background:#fff;right:0;top:50%;margin-top:-0.01rem;}
        }
    .code-txt{margin-top:0.2rem;font-weight:bold;font-size:0.32rem;user-select:text}
    .gift-btn-box{margin-top:0.5rem;}
    .gift-btn{width:3.96rem;height:0.94rem;@include singleBg;margin:0 auto;margin-bottom:0.1rem;}
    .gift-btn-1{background-image:url(./../../assets/gift/gift-btn-1.png);}
    .gift-btn-2{background-image:url(./../../assets/gift/gift-btn-2.png);}
    .gift-btn-3{background-image:url(./../../assets/gift/gift-btn-3.png);}
    .gift-btn-4{background-image:url(./../../assets/gift/gift-btn-4.png);}
    .gift-btn-5{background-image:url(./../../assets/gift/gift-btn-5.png);}
    .input-box{white-space:nowrap; width:5.6rem;display:flex;justify-content:space-between;align-items:center;
        input{padding:0.1rem;width:4rem;}
        margin-top:0.2rem;}
    .address-box{margin-top:0.2rem;}
    .address-title{text-align:left;}
    .address-area{width:5.6rem;margin-top:0.1rem;border:none;resize:none;padding:0.1rem;box-sizing:border-box;}
</style>
